<template>
  <div class="custom-container">
    <div class="custom-wrap" :selected="selected">
      <div class="nav-size-container" v-show="step == 2">
        <div class="nav-size-wrap" id="navSwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              :class="{ on: index == number - 1 }"
              v-for="(item, index) in category"
              @click="selectedPosition(item, index)"
            >
              <div class="box">
                <div class="name">{{ item.remark }}</div>
                <div class="img">
                  <img :src="item.image" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>

      <div class="nav-size-container" v-show="step == 3">
        <div class="view-customized-wrap">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in imgArr"
              @click="jump(index)"
            >
              <img :src="item.url" width="100%" />
            </div>
          </div>
        </div>
      </div>

      <div class="custom-mian-container">
        <div class="lf-custom" v-if="productDetails">
          <div class="basic-information" v-show="step < 3">
            <span>
              {{ productDetails.title }}
            </span>
            <span>
              {{ shoeTypeArr[shoefistIndex].name }}
            </span>
            <span>
              {{ shoelastArr[shoelastIndex].name }}
            </span>
            <span>
              {{ code }}
            </span>
          </div>

          <div class="product-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(itemARR, index) in sizeArr">
                <div
                  class="product-img"
                  :ref="'img' + index"
                  :id="index"
                  v-if="index <= 3"
                >
                  <img
                    :src="item.thumb2 ? item.thumb2 : item.thumb"
                    v-for="(item, index2) in itemARR"
                    :style="{
                      zIndex:
                        item.cate_name == '轮子' ? index2 - 1 : index2 + 1,
                    }"
                    :name="item.name"
                    v-if="item"
                    :id="'viewImg' + index"
                  />
                </div>

                <div class="product-img" :id="index" v-else>
                  <img src="" id="viewImg4" />
                </div>
              </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
          <div class="formark-line" v-if="remark">
            <h6>Rescribe</h6>
            <p>{{ remark }}</p>
          </div>
          <div class="time-line">
            <div
              class="item"
              :class="{ on: imgIndex == index }"
              v-for="(item, index) in list"
              v-if="index <= 3"
            >
              <span>{{ item.name }}</span>
              <em></em>
            </div>
          </div>
        </div>
        <div class="rt-custom">
          <div class="position-box" :name="positionBoxName">
            <div class="product-size" v-if="step == 1">
              <div class="product-size-item">
                <label>
                  <span>Last</span>
                  <el-button type="text" @click="celiangway('')">
                    Last table
                  </el-button>
                </label>
                <div class="dl">
                  <div
                    class="dd"
                    @click="shoefistCLICK(item, idx)"
                    :class="{ on: shapetwo == item.id }"
                    v-for="(item, idx) in shoeTypeArr"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="product-size-item">
                <label>
                  <span>Version</span>
                  <el-button type="text" @click="celiangway('Version')">
                    Version table
                  </el-button>
                </label>
                <div class="dl">
                  <button
                    class="dd"
                    @click="shoelastCLICK(item, index)"
                    :class="{ on: shoelastIndex == index }"
                    v-for="(item, index) in shoelastArr"
                    :disabled="clickableTable(index)"
                  >
                    {{ item.name }}
                  </button>
                </div>
              </div>
              <div class="product-size-item">
                <label>
                  <span>Size</span>
                  <el-button type="text" @click="celiangway('Size')">
                    Size table
                  </el-button>
                </label>
                <div class="dl" v-if="codeArr.length > 0">
                  <button
                    class="dd"
                    @click="optsize(item)"
                    :class="{ on: code == item }"
                    v-for="item in codeArr"
                    :disabled="clickableSize(item)"
                  >
                    {{ item }}
                  </button>
                </div>
              </div>
              <div class="product-size-item">
                <el-input-number v-model="num" :min="1"></el-input-number>
                <div class="unit" v-if="num <= 1">Pair</div>
                <div class="unit" v-if="num > 1">Pairs</div>
                <div class="price" v-if="productDetails">
                  $ {{ (productDetails.price * num).toFixed(2) }}
                </div>
              </div>
              <div class="product-size-item web-bottom-button">
                <button
                  type="button"
                  class="back-button"
                  @click="$router.go(-1)"
                >
                  Back
                </button>
                <button type="button" class="next-button" @click="stepone(2)">
                  Next
                </button>
              </div>
            </div>

            <div class="size-selected-wrap pc-element" v-if="step == 2">
              <div class="size-selected-name" :cn="sizeTitle">
                {{ sizeTitleEng }}
              </div>

              <!-- 非logo部位且选择第一种定制方式 -->

              <div
                v-if="
                  !showCustomized() ||
                  (showCustomized() && form.ways[logoIndex] == 1)
                "
                class="common-size"
              >
                <div class="color-size" v-if="sizeTitle != '附配件'">
                  <div
                    class="color-item"
                    v-for="(item, index) in colorArr"
                    :class="{ on: selectedActiveClass(item) }"
                    @click="selectedSize(item, index)"
                  >
                    <div
                      class="circle"
                      :style="{ backgroundImage: 'url(' + item.thumb + ')' }"
                    ></div>
                    <p>{{ item.name }}</p>
                    <p class="red">${{ item.price }}</p>
                  </div>
                </div>

                <div class="color-size" v-if="sizeTitle == '附配件'">
                  <div
                    class="color-item"
                    v-for="(item, index) in colorArr"
                    :class="{ on: selectedActiveClassAll(item) }"
                    @click="selectedSize(item, index)"
                  >
                    <div
                      class="circle"
                      :style="{ backgroundImage: 'url(' + item.thumb + ')' }"
                    ></div>
                    <p>{{ item.name }}</p>
                    <p class="red">${{ item.price }}</p>
                  </div>
                </div>
              </div>

              <div class="embroidery-form-wrap" v-if="showCustomized()">
                <div class="embroidery-form">
                  <el-form ref="form" :model="form" label-width="100px">
                    <template v-if="form.ways[logoIndex] == 1 && showColorPiker">
                      <el-form-item label="Color" class="el-color-item">
                        <el-color-picker
                          color-format="rgb"
                          v-model="form.color[logoIndex].color1"
                          @change="preview"
                        >
                        </el-color-picker>
                      </el-form-item>
                    </template>


                    <template v-if="form.ways[logoIndex] == 2">
                      <!-- 字体材质图 -->
                      <div class="common-size">
                        <div class="color-size" v-if="fontArr.length > 0">
                          <div
                            class="color-item"
                            v-for="(item, index) in fontArr"
                            :class="{ on: selectedActiveClass(item) }"
                            @click="selectedSize(item, index)"
                          >
                            <div
                              class="circle"
                              :style="{
                                backgroundImage: 'url(' + item.thumb + ')',
                              }"
                            ></div>
                            <p>{{ item.name }}</p>
                            <p class="red">${{ item.price }}</p>
                          </div>
                        </div>
                      </div>

                      <el-form-item label="Color" class="el-color-item">
                        <el-color-picker
                          v-model="form.color[logoIndex].color1"
                          color-format="rgb"
                          @change="changeColor"
                          
                        >
                        </el-color-picker>
                      </el-form-item>

                      <el-form-item
                        label="Words"
                        v-if="sizeTitle == '鞋身图案'"
                      >
                        <el-input
                          v-model="form.logo1"
                          @focus="xieshenfocus"
                          maxlength="10"
                          show-word-limit
                        ></el-input>
                      </el-form-item>

                      <el-form-item label="Left" v-if="sizeTitle == '鞋盖图案'">
                        <el-input
                          v-model="form.logo3"
                          @focus="xieshenfocus"
                          maxlength="10"
                          show-word-limit
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label="Right"
                        v-if="sizeTitle == '鞋盖图案'"
                      >
                        <el-input
                          v-model="form.logo2"
                          @focus="xieshenfocus"
                          maxlength="10"
                          show-word-limit
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label="Words"
                        v-if="sizeTitle == '领口LOGO'"
                      >
                        <el-input
                          v-model="form.logo5"
                          @focus="xieshenfocus"
                          maxlength="10"
                          show-word-limit
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label="Words"
                        v-if="sizeTitle == '后跟图案'"
                      >
                        <el-input
                          v-model="form.logo4"
                          @focus="xieshenfocus"
                          maxlength="10"
                          show-word-limit
                        >
                        </el-input>
                      </el-form-item>
                      <el-form-item>
                        <div class="remark-tips">
                          Tips: Final effect will be depend on actual production
                          effect
                        </div>
                      </el-form-item>
                    </template>

                    <template v-if="form.ways[logoIndex] == 3">
                      <el-form-item label="Color">
                        <el-select v-model="form.customImgColor[logoIndex]">
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <div class="remark-tips">
                          If you upload multi-color pictures, our customer
                          service will contact you to confirm after submitting
                          the order
                        </div>
                      </el-form-item>
                      <el-form-item label="Upload">
                        <el-upload
                          class="avatar-uploader"
                          :show-file-list="false"
                          :auto-upload="false"
                          action=""
                          :on-change="beforeAvatarUpload"
                        >
                          <img
                            v-if="form.imageUrl[logoIndex]"
                            :src="form.imageUrl[logoIndex]"
                            class="avatar"
                          />
                          <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon"
                          ></i>
                        </el-upload>
                      </el-form-item>
                    </template>

                    <el-form-item label="Technology">
                      
                      <span
                        v-if="
                          (productDetails.id == 15 &&
                            sizeTitle == '鞋盖图案') ||
                          (productDetails.id == 14 && sizeTitle == '鞋盖图案')
                        "
                        >Print
                      </span>
                 
                      <span
                        v-else-if="
                          (productDetails.id == 18 &&
                            sizeTitle == '鞋身图案') ||
                          (productDetails.id == 19 && sizeTitle == '鞋身图案')
                        "
                        >Print
                      </span>

                     

                      <el-select v-model="form.technology[logoIndex]" v-else>
                        <el-option
                          v-for="(item,index) in technologyArr"
                          :label="item.label"
                          :key="index"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label-width="0">
                      <div class="size-selected-ways">
                        <button
                          type="button"
                          :class="{ on: calculateWay(item) }"
                          v-for="item in customizedLogo"
                          @click="changeWays(item)"
                        >
                          {{ item.name }}
                        </button>
                      </div>
                    </el-form-item>

                    <el-form-item label-width="0">
                      User defined: Three choose one
                    </el-form-item>
                  </el-form>
                </div>
              </div>

              <div class="remark-tips">
                {{ sizeRemark }}
              </div>

              <div class="size-selected-confirm">
                <el-button
                  @click="stepone(1)"
                  v-if="number == 1"
                  class="back-button"
                >
                  Back
                </el-button>

                <el-button
                  @click="selectedPosition(category[number - 2], number - 2)"
                  v-if="number > 1"
                >
                  <img src="../../assets/lf.png" width="40" />
                </el-button>

                <el-button
                  @click="selectedPosition(category[number], number)"
                  v-if="category.length > number"
                >
                  <img src="../../assets/rt.png" width="40" />
                </el-button>

                <el-button
                  @click="finishCustomization"
                  :loading="loadingbutton"
                  v-show="category.length == number"
                  >Summary</el-button
                >
              </div>
            </div>

            <div class="web-element" v-if="step == 2">
              <div class="size-selected-wrap">
                <van-tabs
                  animated
                  @click="vantabs"
                  v-model="active"
                  :ellipsis="false"
                >
                  <van-tab
                    :title="translate(citem.name)"
                    :key="index2"
                    v-for="(citem, index2) in category"
                  >
                    <vue-scroll :ops="opswep">
                      <div
                        class="color-size-wrap"
                        v-if="form.ways[logoIndex] == 1||!showCustomized()"
                      >
                        <div
                          class="color-item"
                          v-for="(item, index) in colorArr"
                          :class="{ on: selectedActiveClass(item) }"
                          @click="selectedSize(item, index)"
                        >
                          <div
                            class="circle"
                            :style="{
                              backgroundImage: 'url(' + item.thumb + ')',
                            }"
                          ></div>
                          <p>{{ item.name }}</p>
                          <p class="red">${{ item.price }}</p>
                        </div>
                      </div>
                    </vue-scroll>
                  </van-tab>
                </van-tabs>

                <div class="embroidery-form" v-if="showCustomized()">
                  <el-form ref="form" :model="form" label-width="100px">
                    <template v-if="form.ways[logoIndex] == 1  && showColorPiker">
                      <el-form-item label="Color" class="el-color-item">
                        <el-color-picker
                          v-model="form.color[logoIndex].color1"
                          color-format="rgb"
                          @change="preview"
                        >
                        </el-color-picker>
                      </el-form-item>
                    </template>

                    <div v-if="form.ways[logoIndex] == 2">
                      <div class="color-size-wrap" v-if="fontArr.length > 0">
                        <div
                          class="color-item"
                          v-for="(item, index) in fontArr"
                          :class="{ on: selectedActiveClass(item) }"
                          @click="selectedSize(item, index)"
                        >
                          <div
                            class="circle"
                            :style="{
                              backgroundImage: 'url(' + item.thumb + ')',
                            }"
                          ></div>
                          <p>{{ item.name }}</p>
                          <p class="red">￥{{ item.price }}</p>
                        </div>
                      </div>

                      <el-form-item label="Color" class="el-color-item">
                        <el-color-picker v-model="form.color[logoIndex].color1" color-format="rgb" @change="changeColor">
                        </el-color-picker>
                      </el-form-item>

                      <el-form-item
                        label="Words"
                        v-if="sizeTitle == '鞋身图案'"
                      >
                        <el-input
                          v-model="form.logo1"
                          @focus="xieshenfocus"
                          maxlength="5"
                          show-word-limit
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label="Right"
                        v-if="sizeTitle == '鞋盖图案'"
                      >
                        <el-input
                          v-model="form.logo2"
                          @focus="xieshenfocus"
                          maxlength="5"
                          show-word-limit
                        >
                        </el-input>
                      </el-form-item>

                      <el-form-item label="Left" v-if="sizeTitle == '鞋盖图案'">
                        <el-input
                          v-model="form.logo3"
                          @focus="xieshenfocus"
                          maxlength="5"
                          show-word-limit
                        >
                        </el-input>
                      </el-form-item>

                      <el-form-item
                        label="Words"
                        v-if="sizeTitle == '后跟图案'"
                      >
                        <el-input
                          v-model="form.logo4"
                          @focus="xieshenfocus"
                          maxlength="5"
                          show-word-limit
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label="Words"
                        v-if="sizeTitle == '领口图案'"
                      >
                        <el-input
                          v-model="form.logo5"
                          @focus="xieshenfocus"
                          maxlength="5"
                          show-word-limit
                        ></el-input>
                      </el-form-item>

                      <el-form-item>
                          Tips: Final effect will be depend on actual production
                          effect
                      </el-form-item>
                        
                    </div>
                    <template v-if="form.ways[logoIndex] == 3">
                      <el-form-item label="Color">
                        <el-select v-model="form.customImgColor[logoIndex]">
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>   
                        </el-select>
                        <div class="remark-tips">
                          If you upload multi-color pictures, our customer
                          service will contact you to confirm after submitting
                          the order
                        </div>
                      </el-form-item>
                      <el-form-item label="Upload">
                        <el-upload
                          class="avatar-uploader"
                          :show-file-list="false"
                          :auto-upload="false"
                          action=""
                          :on-change="beforeAvatarUpload"
                        >
                          <img
                            v-if="form.imageUrl[logoIndex]"
                            :src="form.imageUrl[logoIndex]"
                            class="avatar"
                          />
                          <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon"
                          ></i>
                        </el-upload>
                      </el-form-item>
                    </template>

                    <el-form-item label="Technology">
                      <span
                        v-if="
                          (productDetails.id == 15 &&
                            sizeTitle == '鞋盖图案') ||
                          (productDetails.id == 14 && sizeTitle == '鞋盖图案')
                        "
                        >Print</span
                      >
                      <el-select v-model="form.technology[logoIndex]" v-else>
                        <el-option
                          v-for="(item,index) in technologyArr"
                          :label="item.label"
                          :key="index"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label-width="0">
                      <div class="size-selected-ways">
                        <button
                          type="button"
                          :class="{ on: calculateWay(item) }"
                          v-for="(item,index) in customizedLogo"
                          :key="index"
                          @click="changeWays(item)"
                        >
                          {{ item.name }}
                        </button>
                      </div>
                    </el-form-item>
                    <el-form-item label-width="0">
                        User defined: Three choose one
                    </el-form-item>
                  </el-form>
                </div>

                <div class="remark-tips">
                  {{ sizeRemark }}
                </div>

                <div class="size-selected-confirm web-bottom-button">
                  <el-button
                    @click="stepone(1)"
                    v-if="number == 1"
                    class="back-button"
                  >
                    Back
                  </el-button>

                  <el-button
                    @click="selectedPosition(category[number - 2], number - 2)"
                    v-if="number > 1"
                    class="back-button"
                  >
                    <img src="../../assets/blf.png" width="40" />
                  </el-button>

                  <el-button
                    @click="selectedPosition(category[number], number)"
                    v-if="category.length > number"
                  >
                    <img src="../../assets/rt.png" width="40" />
                  </el-button>

                  <el-button
                    @click="finishCustomization"
                    :loading="loadingbutton"
                    v-show="category.length == number"
                    >Summary</el-button
                  >
                </div>
              </div>
            </div>

            <div class="confirm-content" v-if="step == 3">
              <div class="table-title">
                {{ order.title }}
              </div>

              <custable :order="order" :category="category"></custable>

              <div class="confirm-number">
                Num: {{ order.num }}
                <span v-if="order.num == 1">Pair </span>
                <span v-else>Pairs </span>
              </div>

              <div class="level-msg">
                <textarea
                  placeholder="Leaving a message:"
                  v-model="order.leaveMsg"
                  rows="4"
                ></textarea>
              </div>

              <div class="product-size">
                <div class="product-size-item web-bottom-button">
                  <button type="button" class="back-button" @click="stepone(2)">
                    Cancel
                  </button>
                  <button type="button" class="next-button" @click="goToPay">
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";

import custable from "@/components/custable";

import { Toast } from "vant";
import { mapState } from "vuex";

export default {
  name: "customized",
  data() {
    return {
      selected: 0,
      definition: 1.5, //定制文字清晰度 1.5倍 越高越卡
      fontArr: [],
      sizeRemark: "",
      partsArr: [], //附配件数组
      active: 0,
      shapetwo: 0,
      shoeDefault: 0,
      code: 0, //码数
      step: 1, //第一步先选择尺寸，准头，版型 //第二部选择定制  第三部确定定制
      remark: "", //鞋部位简介
      categorySwiper: {},
      codeArr: [],
      num: 0,
      productDetails: null,
      shoefistIndex: 0, //楦头
      shoelastIndex: 0, //版型
      shoeTypeArr: [], //楦头类型
      shoelastArr: [
        {
          name: "Average", //A
        },
        // {
        //   name: "Narrow", //窄版N
        // },
        {
          name: "Wide", //肥版W
        },
      ],
      loadingbutton: false,
      logoIndex: 0,
      verifyFlag: true, //完成定制之后的验证 是否符合定制
      options: this.global_variable.options,
      customizedLogo: [
        {
          value: 1,
          name: "Pattern",
        },
        {
          value: 2,
          name: "Words",
        },
        {
          value: 3,
          name: "Custom picture",
        },
      ],
      shapeprice: this.global_variable.shapeprice,
      technologyArr: this.global_variable.technologyArr,
      waysthreeLength: 0, //选第三种方式的长度
      form: {
        ways: [1, 1, 1, 1], //方式1 固定图案 方式2 自定义文字 方式3自定义图片
        imageUrl: ["", "", "", ""], //方式3上传的图片  图片格式 base64
        imageUrlAfter: [], //http图片
        technology: ["Print", "Print", "Print", "Print"],
        color: [
          {
            color1: "rgb(255, 255, 255)",
            color2: "rgb(255, 255, 255)",
          },
          {
            color1: "rgb(255, 255, 255)",
            color2: "rgb(255, 255, 255)",
          },
          {
            color1: "rgb(255, 255, 255)",
            color2: "rgb(255, 255, 255)",
          },
          {
            color1: "rgb(255, 255, 255)",
            color2: "rgb(255, 255, 255)",
          },
        ],
        customCommonColor: ["0", "0", "0", "0"], //0默认不自定义 1位单色 2为双色 3多色
        customImgColor: ["1", "1", "1", "1"], //1位单色 2为双色 3多色
        logoflag: [false, false, false, false],
        logo1: "", //鞋身
        logo2: "", //右鞋盖
        logo3: "", // 左鞋盖
        logo4: "", //后跟图案
        logo5: "", //领口图案
      },
      category: [], //分类
      sizeArr: [], //
      imgObjectArr: [],
      productSwiper: null,
      sizeTitle: "", //材质标题
      sizeTitleEng: "", //英文材质标题
      positionBoxName: null, //当前选中规格
      colorArr: [], //材质数组
      list: [], //主图列表
      number: 0, //图层
      imgIndex: 0, //当前主图索引
      goods_id: 0, //商品id
      imgArr: [], //canvas图片
      rest: 2,
      toolCarrierId: 0,
      lunziId: 0,
      screening: [], // //screening后台设置的默认值
      daojiaIndex: 0,
      lunziIndex: null,
      lingkoulogoIndex: null,
      xieshenlogoIndex: null,
      xiegailogoIndex: null,
      hougenlogoIndex: null,
      zhouchenIndex: null,
      viewSwiper: null,
      wordImg: [], //文字
      opswep: {
        bar: {
          opacity: 0, //滚动条透明度
        },
        rail: {
          keepShow: false,
        },
      },
      showColorPiker:false
    };
  },
  watch: {},
  components: {
    custable,
  },
  computed: {
    ...mapState({
      web: (state) => state.web,
      order: (state) => state.order,
    }),
  },
  mounted() {
    this.goods_id = this.$route.params.id;
    this.getProduct();
  },
  methods: {
    getEmPrice(text) {
      var price = 0;
      if (!text) {
        return 0;
      }
      this.global_variable.technologyArr.forEach(function (item, b) {
        if (item.value == text) {
          price = item.price;
        }
      });

      return price;
    },

    translate(e) {
      var text = "";

      this.category.forEach(function (val, index, arr) {
        if (e == val.name) {
          text = val.remark;
        }
      });

      return text;
    },
    stepone(step) {

      var app = this; 
      this.loadingbutton = false;
      this.step = step;

      if (step == 2) {
        this.imgArr = [];

        app.$nextTick(function () {
          app.categorySwiper = new Swiper("#navSwiper", {
            slidesPerView: 7,
            spaceBetween: 20,
            navigation: {
              nextEl: ".nav-size-wrap .swiper-button-next",
              prevEl: ".nav-size-wrap .swiper-button-prev",
            },
          });
        });
      }

      if (step == 3) {
        app.$nextTick(function () {
          app.viewSwiper = new Swiper(".view-customized-wrap", {
            slidesPerView: 4,
            spaceBetween: 20,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
        });
      }

     
    },

    showCustomized() {
      var sizeTitle = this.sizeTitle;

      var flag =
        sizeTitle == "鞋身图案" ||
        sizeTitle == "鞋盖图案" ||
        sizeTitle == "后跟图案" ||
        sizeTitle == "领口图案";

      return flag;
    },
    goToPay() {
        this.$router.push("/payment");
    },
    getProduct() {
      var app = this;

      this.$api("/index/getGoodsDetail", {
        id: this.goods_id,
      }).then(function (res) {
        if (res.status == "200") {
          app.productDetails = res.data;
          const {here_list} = res.data
          let shoeTypeArr=[]
          // 过滤显示选项
          for (const key in here_list) {
            if (Object.hasOwnProperty.call(here_list, key)) {
              const element = here_list[key];
              if(element.name == 'Marathon Last I' && !res.data.title.includes('MODE Ⅱ KIDS')){
                continue;
              }
              else if(element.name == 'Marathon Last II' && res.data.title.includes('MODE Ⅱ KIDS')){
                continue;
              }
              else{
                shoeTypeArr.push(element)
              }
            }
          }
          // console.log('shoeTypeArr: ', shoeTypeArr);
          app.shoeTypeArr = shoeTypeArr;
          app.shoeDefault = res.data.here; //默认楦头id

          app.shapetwo = app.shoeDefault;
          
          

          app.codeArr = res.data.code.split(",");
          app.codeInit(); //初始化尺码
          app.getGoodsCategory();
         
            
          for (const key in app.shoeTypeArr) {
            if (Object.hasOwnProperty.call(app.shoeTypeArr, key)) {
              const element = app.shoeTypeArr[key];
              if(element.id == app.shoeDefault){
                app.shoefistIndex = Number(key);
                break;
              }
            }
          }
        }
      });
    },
    getEmPrice(text) {
      var price = 0;
      if (!text) {
        return 0;
      }
      this.global_variable.technologyArr.forEach(function (item, b) {
        if (item.value == text) {
          price = item.price;
        }
      });

      return price;
    },
    getCusPrice(text) {

      return 0;


      if (text == 1) {
        return this.global_variable.options[0].price;
      } else if (text == 2) {
        return this.global_variable.options[1].price;
      } else if (text == 3) {
        return 0;
      }
    },
    addSize(price) {

      var p = 0;

      var sizeArr = this.$api2.getStorageItem("size");

      //选择的楦头和系统默认返回的楦头不一致就+400块

      if (this.shapetwo && this.shapetwo != this.shoeDefault) {
        p += this.shapeprice;
      }

      sizeArr.forEach((item) => {
        if (item && item.price) {
          p += parseFloat(item.price);
          if (item.tprice) {
            p += parseFloat(item.tprice);
          }
        }
      });
      var embroidery = this.$api2.getStorageItem("embroidery");

      embroidery.ways.forEach((item, index) => {
        if (item == 1) {
          if (embroidery.logoflag[index]) {
            p += this.getEmPrice(embroidery.technology[index]);
          }
        }
        if (item == 2) {
          p += this.getEmPrice(embroidery.technology[index]);
        }
        if (item == 3) {
          p += this.getCusPrice(embroidery.customImgColor[index]);
        }
      });

      return Number(price) + p;
    },
    changeColor() {

      var string = this.number.toString();

      if (!this.sizeArr[0][string]) {
        this.showToast("Choose the font first");
        return;
      }

      this.preview();
    },
    preview() {
      var app = this;

      var color = app.form.color[app.logoIndex].color1;

      console.log(color)

      this.sizeArr.forEach(function (item, index) {
        var canvas = document.createElement("canvas");
        var width = 500 * app.definition;
        var height = 332.5 * app.definition;
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        var string = app.number.toString();

        var img = new Image();
        img.crossOrigin = "anonymous";

        ctx.fillStyle = color;

        if (item[string]) {
          img.src = item[string].thumb + "?t=" + new Date().getTime();
          var rgbRegex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;
          console.log(img);

          img.onload = function () {

            ctx.drawImage(img, 0, 0, width, height);

            var imageD = ctx.getImageData(0, 0, width, height);
            var pdata = imageD.data;
            var colorArr = color.match(rgbRegex);

            for (var j = 0; j < pdata.length; j += 4) {
              pdata[j] = colorArr[1];
              pdata[j + 1] = colorArr[2];
              pdata[j + 2] = colorArr[3];
            }

            ctx.putImageData(imageD, 0, 0);

            // 更新新数据


            // item[string].thumb  =  canvas.toDataURL("image/png");

            app.$set(item[string], "thumb2", canvas.toDataURL("image/png"));

            app.selected = new Date().getTime();
          };
          
        }
      });
    },
    buynow() {
      var app = this;

      var shapeprice = 0;

      if (this.shapetwo != this.shoeDefault) {
        shapeprice += this.shapeprice;
      }

      // app.$api2.setGhStorageItem("embroidery", app.form);
      // app.$api2.setGhStorageItem("imgArr", app.imgArr);

      var imgArr = app.$api2.getStorageItem("imgArr");

      this.$store.commit("SET_ORDER", {
        type: 2,
        id: this.productDetails.id, //商品id
        num: this.num, //数量
        originalprice: this.productDetails.price, //商品原价
        shape: this.shoelastArr[this.shoelastIndex]["name"], //版型中文名
        shapetwo: this.shapetwo ? this.shapetwo : this.shoeDefault, //楦头id
        shapetwoValue: this.shoeTypeArr[this.shoefistIndex].name, //楦头名字
        shapeprice: shapeprice, //楦头价格  (默认楦头0元 其他+400)
        title: this.productDetails.title,
        code: this.code,
        thumb: this.productDetails.thumb,
        price: this.addSize(this.productDetails.price),
        //定制完之后的单件总价
        size: this.$api2.getStorageItem("size"), //材质item 数组
        category: this.category,
        imgArray: imgArr.length == 0 ? "" : imgArr, //处理好的图片数组sizeArr
        embroidery: this.$api2.getStorageItem("embroidery"), //embroidery表单
      });

      console.log("buy now")

      this.stepone(3);
      // this.$router.push("/payment")
    },

    checkabled: function () {
      switch (this.shoefistIndex) {
        case 0:
          return false;
          break;
        case 1:
          if (this.shoelastIndex == 1 || this.shoelastIndex == 2) {
            this.shoelastIndex = 0;
          }
          break;
        case 2:
          if (this.shoelastIndex == 1) {
            this.shoelastIndex = 0;
          }
          if (this.size >= 25 && this.size <= 35) {
            if (this.shoelastIndex == 2) {
              this.shoelastIndex = 0;
            }
          }
          return false;
          break;
        case 3:
          if (this.shoelastIndex == 1) {
            this.shoelastIndex = 0;
          }
          if (this.size <= 34) {
            if (this.shoelastIndex == 2) {
              this.shoelastIndex = 0;
            }
          }
          return false;
          break;
        default:
      }
    },
    shoefistCLICK(item, index) {
      this.shoefistIndex = index;
      this.shapetwo = item.id;
      this.checkabled();
    },
    optsize(code) {
      this.shoelastIndex = 0;
      this.code = code;
    },
    shoelastCLICK(item, index) {
      this.shoelastIndex = index;

      this.shape = item.name;
    },
    clickableSize(item) {
      if (this.shoefistIndex == 0 && item <= 28) {
        return true;
      }
      if (this.shoefistIndex == 3 && item <= 28) {
        return true;
      }
      
    },
    celiangway(data) {
      window.open(location.origin + "/productArticle#" + data);
    },

    codeInit() {
      //HOPE楦头 和 G楦头  不能选择 29码以前的
      //如果是成人款 最小码就默认数组第一个 儿童款就是29
      if (this.shoefistIndex == 0 || this.shoefistIndex == 3) {
        if (this.codeArr[0] > 29) {
        } else {
          this.code = 29;
          return;
        }
      }

      this.code = this.codeArr[0];
    },
    clickableTable:function(index){
      if(index == 0){
        return false;
      }
      else{

        if(this.shoeTypeArr[this.shoefistIndex]){
  
          let id = this.shoeTypeArr[this.shoefistIndex].id
         
          switch (this.goods_id) {
            case '14':
              if([1,5,3].includes(id)){
                return false
              }
              break;
            case '15':
              if([1,5].includes(id)){
                return false
              }
              break;
            case '16':
              if([1,5,3].includes(id)){
                return false
              }
              break;
            case '17':
              if([1,3].includes(id)){
                return false
              }
              break;
            case '18':
              if([1,5,3].includes(id)){
                return false
              }
              break;
            case '19':
              if([1,5,3].includes(id)){
                return false
              }
              break;
            default:
              break;
          }
          return true
        }
        
      }
    },
    clickable: function (index) {
      
      console.log('clickable index = ', index,'this.shoefistIndex = ',this.shoefistIndex);
      //shoefistIndex----楦头
      //index A N W;
      switch (this.shoefistIndex) {
        case 0:
          return false;
          break;
        case 1:
          if (index == 1 || index == 2) {
            return true;
          }
          
          return false;
          break;
        case 2:
          if (index == 1) {
            if(this.goods_id == 15){
              return true;
            }
            return false;
          }
          if (this.size >= 25 && this.size <= 35) {
            if (index == 2) {
              return true;
            }
          } else {
            return false;
          }

          break;
        case 3:
          if(this.goods_id == 15){
                return false;
          }
          if (index == 1) {
            return true;
          }
          if (this.size <= 34) {
            if (index == 2) {
              return true;
            }
          } else {
            return false;
          }
          return false;
          break;
        case 4:
          if (index == 0 || index == 1) {
            if((this.goods_id == 15 || this.goods_id == 17) && index == 1){
                return true;
            }
            return false;
          } else {
            return true;
          }

          break;
        case 5:
          if (index == 0) {
            return false;
          } else {
            return true;
          }
          break;
        default:
          return false;
      }
    },
    selectedActiveClassAll(item) {
      // 可重复

      var flag = false;

      this.partsArr.forEach((itemsize) => {
        if (itemsize.cate_name == item.cate_name) {
          if (itemsize.id == item.id) {
            flag = true;
          }
        }
      });

      return flag;
    },
    selectedActiveClass(item) {
      // console.log('item: ', item,this.sizeArr[0]);
      // 不可重复

      var flag = false;

      this.sizeArr[0].forEach((itemsize) => {
        if (itemsize.cate_name == item.cate_name) {
          if (itemsize.id == item.id) {
            flag = true;
          }
        }
      });

      return flag;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.raw.type === "image/jpeg";
      const isLt2M = file.raw.size / 1024 / 1024 < 2;

      console.log(isJPG);
      console.log(isLt2M);

      if (!isJPG) {
        this.showToast("Only JPG files can be uploaded");
        return isJPG;
      }
      if (!isLt2M) {
        this.showToast("The size cannot exceed 2M");
        return isLt2M;
      }

      var app = this;

      this.getBase64(file.raw).then((res) => {
        app.$set(app.form.imageUrl, app.logoIndex, res);
      });

      console.log(app.form.imageUrl);

      return false;
    },
    changeWays(item) {

      if(item.value==1){
        this.selectedSize(this.colorArr[0], 0)
      }
      
      if(item.value==2){
        this.selectedSize(this.fontArr[0], 0)
      }
      

      this.$set(this.form["ways"], this.logoIndex, item.value);
      
    },
    calculateWay(item) {
      if (item.value == this.form.ways[this.logoIndex]) {
        return true;
      } else {
        return false;
      }
    },
    xieshenfocus() {

    },

    vantabs(e) {


      this.selectedPosition(this.category[e], e);
    },
    getGoodsCategory() {
      var app = this;

      app
        .$api("/index/getGoodsCategory", {
          goods_id: app.goods_id,
        })
        .then(function (res) {
          app.list = res.data.list;

          app.screening = res.data.screening;

          app.category = app.list[0].category;

          app.category.forEach((item, index) => {
            var Level = index + 1;

            switch (item.name) {
              case "轮子":
                app.lunziIndex = Level;
                break;
              case "刀架":
                app.daojiaIndex = Level;
                break;
              case "鞋身图案":
                app.xieshenlogoIndex = Level;
                break;
              case "领口LOGO":
                app.lingkoulogoIndex = Level;
                break;
              case "鞋盖图案":
                app.xiegailogoIndex = Level;
                break;
              case "后跟图案":
                app.hougenlogoIndex = Level;
                break;
              case "轴承":
                app.zhouchenIndex = Level;
                break;
            }
          });

          app.list.forEach((item, index) => {
            app.wordImg[index] = [];
            app.sizeArr[index] = [];
            app.imgObjectArr[index] = [];
            app.draw(item, index);
          });

          app.$nextTick(function () {
            app.productSwiper = new Swiper(".product-swiper-container", {
              initialSlide: 0,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              on: {
                slideChange: function (swiper) {
                  app.imgIndex = this.activeIndex;
                },
              },
            });

            app.selectedPosition(app.category[0], 0);
          });
        });
    },
    draw(item, index) {
      var app = this;

      //第一次进来没有规格 放底图 先走else
      if (app.sizeArr.length > 0 && app.sizeArr[index].length > 0) {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        canvas.width = 1000;
        canvas.height = 665;
        app.imgObjectArr[index] = [];

        for (var i = 0; i < app.sizeArr[index].length; i++) {
          if (app.sizeArr[index][i] && app.sizeArr[index][i].thumb) {
            var img = new Image();

            img.crossOrigin = "anonymous";


            if (app.sizeArr[index][i].cate_name == "轮子") {
              img.src =
                app.sizeArr[index][app.daojiaIndex].thumb +
                "?t=" +
                new Date().getTime();
            } else if (app.sizeArr[index][i].cate_name == "刀架") {
              img.src =
                app.sizeArr[index][app.lunziIndex].thumb +
                "?t=" +
                new Date().getTime();
            } else {
              img.src =
                app.sizeArr[index][i].thumb + "?t=" + new Date().getTime();
            }

            app.imgObjectArr[index].push(img);

            // app.imgObjectArr[index].push({img:img,title:app.sizeArr[index][i].name})
          }
        }

        var pr = [];

        app.imgObjectArr[index].forEach((item) => {
          // 预加载图片
          let p = app
            .loadImage(item)
            .then((img) => {
              return img;
            })
            .catch((err) => console.log());

          pr.push(p);
        });

        Promise.all(pr).then((res) => {
          for (var i = 0; i < res.length; i++) {
            if (res[i]) {
              ctx.drawImage(res[i], 0, 0, 1000, 665);
            }
          }
          app.cosUpload(canvas.toDataURL("image/png"), app, index);
        });
      } else {

        app.$set(app.sizeArr[index], 0, {
          thumb: item.img,
          price: 0,
        });

        if (index == 3) {
          app.category.forEach((bigitem, bigindex) => {
            app.screening.forEach((item, index) => {
              if (bigitem.id == item.main_id) {
                app.number = bigindex + 1;
                app.selectedSize(item, null, true);
              }
            });
          });
        }
      }
    },
    cosUploadCustom(base64Img, app, index) {
      app
        .$api(
          "/cos/upload",
          {
            goods_id: this.goods_id,
            base64: base64Img,
          },
          "POST"
        )
        .then(function (res) {
          if (res.status == 200) {
            app.form.imageUrlAfter.push({
              url: res.data.url,
              id: index,
            });

            if (app.form.imageUrlAfter.length == app.waysthreeLength) {
              app.list.forEach((item, index) => {
                app.draw(item, index);
              });
            }
          } else {
            app.loadingbutton = false;
            app.showToast(res.msg);
          }
        })
    },
    cosUpload(base64Img, app, index) {
      app
        .$api(
          "/cos/upload",
          {
            goods_id: this.goods_id,
            base64: base64Img,
          },
          "POST"
        )
        .then(function (res) {
          if (res.status == 200) {
            app.imgArr.push({
              url: res.data.url,
              id: index,
            });

            console.log(app.imgArr.length+"_______"+app.list.length)

            // BASE64图片处理之后长度等于list长度证明全部处理完毕getStorageItem
            if (app.imgArr.length == app.list.length) {

              app.loadingbutton = false;

              app.$api2.setStorageItem("embroidery", app.form);
              console.log(app.form)

              app.imgArr.forEach((it, idx) => {
                if (it.id == 4) {
                  app.imgArr.splice(idx, 1);
                }
              });

              app.$api2.setStorageItem("imgArr", app.imgArr);

              app.buynow();
            }
          }

          
        }).catch(()=>{
            app.showToast("error");
            app.loadingbutton = false;
        });
    },
    showToast(msg) {
      this.global_variable.showWranToast(msg);
      this.verifyFlag = false;
    },
    finishCustomization() {

      var app = this;

      var pirceArr = [];

      this.waysthreeLength = 0;
      this.form.imageUrlAfter = [];

      this.verifyFlag = true;

      this.loadingbutton = true;


      app.sizeArr[0].forEach((item, index) => {
        if (item) {
          pirceArr.push({
            url:item.url,
            engcate_name: item.remark,
            cate_name: item.cate_name,
            price: item.price,
            main_id: item.main_id,
            id: item.id,
            name: item.name,

          });
        } else {
          pirceArr.push({
            price: 0,
          });
        }
      });

      app.form.ways.forEach((item, index) => {
        //第二种方式
        if (item == 2) {
          switch (index) {
            case 0:
              if (!app.form.logo1) {
                app.showToast("Please input Vamp Logo ");
                return;
              }
              break;
            case 1:
              if (!app.form.logo2 || !app.form.logo3) {
                app.showToast("Please input Lace Cover Logo ");
                return;
              }

              break;
            case 2:
              if (!app.form.logo4) {
                app.showToast("Please input Heel Logo ");
                return;
              }
              break;
            case 3:
              if (!app.form.logo5) {
                app.showToast("Please input Base Logo");
                return;
              }
              break;
          }
        }
        //第三种方式
        if (item == 3) {
          switch (index) {
            case 0:
              if (!app.form.imageUrl[0]) {
                app.showToast("Please upload Vamp Logo picture ");
              } else {
                app.waysthreeLength++;
              }
              break;
            case 1:
              if (!app.form.imageUrl[1]) {
                app.showToast("Please upload Lace Cover Logo picture ");
                return;
              } else {
                app.waysthreeLength++;
              }
              break;
            case 2:
              if (!app.form.imageUrl[2]) {
                app.showToast("Please upload Heel Logo picture ");
                return;
              } else {
                app.waysthreeLength++;
              }
              break;
            case 3:
              if (!app.form.imageUrl[3]) {
                app.showToast("Please upload Base Logo picture");
                return;
              } else {
                app.waysthreeLength++;
              }
              break;
          }
        }
      });

      if (!this.verifyFlag) {
        this.loadingbutton = false;
        return;
      }

      //定制的第三种方式大于0;
      if (app.waysthreeLength > 0) {
        app.form.imageUrl.forEach((item, index) => {
          // console.log(item)
          if (item) {
            app.cosUploadCustom(item, app, index);
          }
        });
      } else {
        
        app.list.forEach((item, index) => {

           app.draw(item, index);
           
        });
      }

      var concat = pirceArr.concat(this.partsArr);

      app.$api2.setStorageItem("size", concat);
    },

    jump(index) {
      this.productSwiper.slideTo(index);
    },

    selectedSize(sizeItem, indexXX = null, first = false) {

      var app = this;

 
      if(sizeItem.name.indexOf("Custom")==0){
        this.showColorPiker = true;
      }else{
        if(this.showCustomized()){
           this.showColorPiker = false;
           this.form.color[this.logoIndex].color1 = "rgb(255, 255, 255)"
        }
      }

      if (sizeItem.cate_name == "鞋身图案") {
        if (sizeItem.color_flag == "Y") {
          app.form.customCommonColor[0] = 1;
        } else {
          app.form.customCommonColor[0] = 0;
        }
      }

      if (sizeItem.cate_name == "鞋盖图案") {
        if (sizeItem.color_flag == "Y") {
          app.form.customCommonColor[1] = 1;
        } else {
          app.form.customCommonColor[1] = 0;
        }
      }

      if (sizeItem.cate_name == "后跟图案") {
        if (sizeItem.color_flag == "Y") {
          app.form.customCommonColor[2] = 1;
        } else {
          app.form.customCommonColor[2] = 0;
        }
      }

      if (sizeItem.cate_name == "领口图案") {
        if (sizeItem.color_flag == "Y") {
          app.form.customCommonColor[3] = 1;
        } else {
          app.form.customCommonColor[3] = 0;
        }
      }

      this.sizeRemark = "";

      this.imgArr = [];

      if (!first) {
        this.sizeRemark = "";
        this.sizeRemark = sizeItem.remark;
      }

      if (sizeItem.cate_name == "附配件") {

        let length = this.partsArr.length;

        document.getElementById("viewImg4").src = sizeItem.imgList[0];

        this.partsArr.forEach((item, index) => {
          if (item.id == sizeItem.id) {
            app.partsArr.splice(index, 1);
          }
        });
        if (length == this.partsArr.length) {

          app.partsArr.push({
            engcate_name: sizeItem.remark,
            id: sizeItem.id,
            cate_name: sizeItem.cate_name,
            name: sizeItem.name,
            price: Number(sizeItem.price),
            main_id: sizeItem.main_id,
            thumb:sizeItem.thumb
          });

        }
        return;
      }

      //取消已选择项 设为空

      app.list.forEach((item, index) => {
        if (index > 3) {
          return;
        }

        // if(item.cate_name == sizeItem.cate_name ){
        // 	remark
        // }

        app.$set(app.sizeArr[index], app.number, {
            engcate_name: sizeItem.remark,
            id: sizeItem.id,
            cate_name: sizeItem.cate_name,
            name: sizeItem.name,
            price: Number(sizeItem.price),
            main_id: sizeItem.main_id,
            thumb: sizeItem.imgList[index],
            url:sizeItem.thumb
        });
      });

      app.positionBoxName = sizeItem.cate_name + indexXX;

      if (this.showCustomized() && this.form["ways"][this.logoIndex] == 2) {
         this.changeColor();
      }
    },
    selectedPosition(item, index) {

      console.log('selectedPosition item, index: ', item, index);

      var app = this;

      if (item.name == "鞋身图案") {
        this.logoIndex = 0;
      }
      if (item.name == "鞋盖图案") {
        this.logoIndex = 1;
      }
      if (item.name == "后跟图案") {
        this.logoIndex = 2;
      }
      if (item.name == "领口LOGO") {
        this.logoIndex = 3;
      }

      if (item.name == "轮子") {
        this.rest = 1;
      } else if (item.name == "轴承") {
        this.rest = 3;
      } else {
        this.rest = 2;
      }

      if (item.name == "轴承") {
        if (this.sizeArr[0][app.lunziIndex].length == 0) {
          this.showToast("Choose the wheels first");
        }
      }

      this.number = index + 1;
      this.active = index;

      if (this.categorySwiper && this.step == 2) {
        this.categorySwiper.slideTo(this.number - 1, 1000);
      }

      this.sizeTitleEng = item.remark; //英文title

      this.sizeTitle = item.name;

      this.colorArr = [];

      app.list.forEach((img, listindex) => {
        if (img.id == item.img_id) {
          app.imgIndex = listindex; //当前图片索引

          app.productSwiper.slideTo(listindex);
        }
      });
      
      app
        .$api("/index/getCustomScreening", {
          cat_id: item.id,
          goods_id: item.goods_id,
          code: this.code,
          rest: this.rest,
          son_id: this.sizeArr[0][app.daojiaIndex]
            ? this.sizeArr[0][app.daojiaIndex].id
            : null, //刀架id
          son_id_two: this.sizeArr[0][app.lunziIndex]
            ? this.sizeArr[0][app.lunziIndex].id
            : null, //
        })
        .then(function (res) {
          app.colorArr = res.data.screening;

          app.fontArr = res.data.font;
          
        });
         console.log('selectedPosition 2');
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    loadImage(obj) {
      // 预加载图片
      return new Promise((resolve, reject) => {
        obj.onload = () => resolve(obj);
        obj.onerror = reject;
      });
    },
  },
};
</script>


<style lang="less">

.remark-tips {
  line-height: 1.5;
  color: #999;
  margin-top: 20px;
}
.custom-container {
  .van-tab {
    padding: 0 10px;
  }
}
.van-tabs__line {
  background-color: #90c31f;
}

@import "../../assets/css/customized.less";
@import "../../assets/css/webcustomized.less";
</style>



// WEBPACK FOOTER //
// src/pages/customized/customized.vue